/* eslint-disable */
import React from 'react';
import { Link } from 'react-router-dom';

import ReviewCard from './ReviewCard';
import { reviews } from './reviewsData';

const wrapperStyle = {
  background:
    'radial-gradient(circle at top, #3A1F52 0, #170824 45%, #12061f 100%)',
  padding: '40px 24px',
  color: '#F5F5FA',
  fontFamily:
    'system-ui, -apple-system, BlinkMacSystemFont, "Segoe UI", sans-serif',
};

const innerStyle = {
  maxWidth: 1100,
  margin: '0 auto',
};

const headingStyle = {
  fontSize: 22,
  fontWeight: 600,
  marginBottom: 6,
  textAlign: 'center',
};

const subStyle = {
  fontSize: 13,
  opacity: 0.75,
  textAlign: 'center',
  marginBottom: 24,
};

const rowStyle = {
  display: 'flex',
  gap: 18,
  flexWrap: 'wrap',
  justifyContent: 'center',
  alignItems: 'flex-start',
};

const linkRowStyle = {
  marginTop: 24,
  textAlign: 'center',
};

const linkStyle = {
  color: '#E9D7F4',
  textDecoration: 'none',
  fontSize: 13,
  borderBottom: '1px solid rgba(233,215,244,0.4)',
  paddingBottom: 1,
};

const ReviewsStrip = () => {
  const featured = reviews.filter(r => r.featured).slice(0, 3);
  if (featured.length === 0) return null;

  return (
    <div style={wrapperStyle}>
      <div style={innerStyle}>
        <h2 style={headingStyle}>What our customers say</h2>
        <div style={subStyle}>Real reviews from real Bay Area + Tacoma customers.</div>
        <div style={rowStyle}>
          {featured.map(r => (
            <ReviewCard key={r.id} review={r} />
          ))}
        </div>
        <div style={linkRowStyle}>
          <Link to="/Reviews" style={linkStyle}>Read all reviews →</Link>
        </div>
      </div>
    </div>
  );
};

export default ReviewsStrip;
